import React from 'react';
import { Chip } from '@mui/material';
import { RoletaStatus } from '../../models/roleta';

type Tone = 'default' | 'primary' | 'warning' | 'info' | 'success';

const TONE_BY_STATUS: Record<string, Tone> = {
  [RoletaStatus.Draft]: 'default',
  [RoletaStatus.Active]: 'success',
  [RoletaStatus.Inactive]: 'warning',
  [RoletaStatus.Closed]: 'default',
};

interface Props {
  status?: string;
}

const RoletaStatusChip: React.FC<Props> = ({ status }) => {
  if (!status) return null;
  const label = RoletaStatus.translateStatus(status as RoletaStatus) || status;
  return <Chip size="small" label={label} color={TONE_BY_STATUS[status] ?? 'default'} />;
};

export default RoletaStatusChip;
